import { setStorageAuthToken, setStorageRefreshToken, setStorageUserId } from 'utils';

export const impersonateAuth = () => {
  const params = new URL(window.location.href).searchParams;
  const authParams = JSON.parse(params.get('impersonate') || '{}');

  if (authParams.user) {
    setStorageAuthToken(authParams.token);
    setStorageRefreshToken(authParams.refresh_token);
    setStorageUserId(authParams.user.id);

    window.location.href = window.location.href.split('?')[0];
  }
};
